var _a;
import { ReactionType } from './types';
export var VitalsDataSource;
(function (VitalsDataSource) {
    VitalsDataSource["patientReported"] = "patientReported";
    VitalsDataSource["clinicianMeasured"] = "clinicianMeasured";
})(VitalsDataSource || (VitalsDataSource = {}));
export var vitalsDataSourceLabels = (_a = {},
    _a[VitalsDataSource.patientReported] = 'Patient Reported',
    _a[VitalsDataSource.clinicianMeasured] = 'Clinician Measured',
    _a);
export var reactionTypeSortOrder = [ReactionType.allergy, ReactionType.adverseReaction];
